<template>
  <sub-page title="个人富民创业担保贷款申请（资质认定）">
    <div class="loan-page">
      <!-- 资格提示 -->
      <div class="notice-card">
        <div class="notice-title">温馨提示</div>
        <div class="notice-line">经查询，您名下暂无登记的经营实体信息，暂不符合个人富民创业担保贷款申请条件。如需办理，请先到经营地所在街道（乡镇）人社平台完成单位基础信息采集。</div>
      </div>

      <!-- 个人申请基本信息 -->
      <div class="section-title">个人申请基本信息</div>
      <div class="form-body" @click="onFormClick">
        <div class="form-item">
          <span class="form-label required">注册区划</span>
          <div class="picker" @click="selectField('注册区划')">
            <span :class="['picker-value', { placeholder: !form.region }]">{{ form.region || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">统一信用代码</span>
          <input v-model="form.creditCode" class="form-input" placeholder="请输入统一信用代码" />
        </div>
        <div class="form-item">
          <span class="form-label required">经营实体名称</span>
          <input v-model="form.entityName" class="form-input" placeholder="请输入经营实体名称" />
        </div>
        <div class="form-item">
          <span class="form-label required">贷款次数</span>
          <input v-model="form.loanCount" class="form-input" placeholder="请输入贷款次数" />
        </div>
        <div class="form-item">
          <span class="form-label required">成立</span>
          <div class="picker" @click="selectField('成立')">
            <span :class="['picker-value', { placeholder: !form.establish }]">{{ form.establish || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">经营</span>
          <div class="picker" @click="selectField('经营')">
            <span :class="['picker-value', { placeholder: !form.business }]">{{ form.business || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">用工</span>
          <div class="picker" @click="selectField('用工')">
            <span :class="['picker-value', { placeholder: !form.employ }]">{{ form.employ || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">其中</span>
          <div class="picker" @click="selectField('其中')">
            <span :class="['picker-value', { placeholder: !form.among }]">{{ form.among || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label">个人贷款编号</span>
          <input v-model="form.loanNo" class="form-input" placeholder="请输入个人贷款编号" />
        </div>
      </div>

      <!-- 申请录入信息 -->
      <div class="section-title">申请录入信息</div>
      <div class="form-body" @click="onFormClick">
        <div class="form-item">
          <span class="form-label required">人员类别</span>
          <div class="picker" @click="selectField('人员类别')">
            <span :class="['picker-value', { placeholder: !form.personType }]">{{ form.personType || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">移动电话</span>
          <input v-model="form.mobile" class="form-input" placeholder="请输入移动电话" />
        </div>
        <div class="form-item">
          <span class="form-label required">婚姻状况</span>
          <div class="picker" @click="selectField('婚姻状况')">
            <span :class="['picker-value', { placeholder: !form.marital }]">{{ form.marital || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">借款用途</span>
          <div class="picker" @click="selectField('借款用途')">
            <span :class="['picker-value', { placeholder: !form.purpose }]">{{ form.purpose || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="footer-btns">
        <button class="upload-btn" @click="uploadMaterial">上传材料</button>
        <button class="submit-btn" @click="handleSubmit">提交</button>
      </div>

      <!-- 字段选择 -->
      <field-sheet
        :show="sheet.show"
        :title="sheet.title"
        :options="sheet.options"
        :value="sheet.value"
        @select="onSheetSelect"
        @close="sheet.show = false"
      />
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'
import FieldSheet from '@/components/FieldSheet.vue'

export default {
  name: 'LoanApply',
  components: { SubPage, FieldSheet },
  data() {
    return {
      form: {
        region: '',
        creditCode: '',
        entityName: '',
        loanCount: '',
        establish: '',
        business: '',
        employ: '',
        among: '',
        loanNo: '',
        personType: '',
        mobile: '',
        marital: '',
        purpose: ''
      },
      fieldOptions: {
        '注册区划': { key: 'region', options: ['南京市玄武区', '南京市秦淮区', '南京市建邺区', '南京市鼓楼区', '南京市浦口区', '南京市栖霞区', '南京市雨花台区', '南京市江宁区', '南京市六合区', '南京市溧水区', '南京市高淳区', '南京市江北新区'] },
        '成立': { key: 'establish', options: ['1年以内', '1（含）-3年', '3（含）-5年', '5年以上'] },
        '经营': { key: 'business', options: ['正常经营', '筹建中', '停业整顿'] },
        '用工': { key: 'employ', options: ['10人以下', '10（含）-50人', '50（含）-200人', '200人以上'] },
        '其中': { key: 'among', options: ['吸纳重点群体0人', '吸纳重点群体1-5人', '吸纳重点群体6-10人', '吸纳重点群体10人以上'] },
        '人员类别': { key: 'personType', options: ['返乡创业农民工', '就业困难人员', '高校毕业生', '复员转业退役军人', '返乡入乡创业人员', '农村自主创业农民', '化解过剩产能企业职工'] },
        '婚姻状况': { key: 'marital', options: ['未婚', '已婚', '离异', '丧偶'] },
        '借款用途': { key: 'purpose', options: ['创业开办', '扩大经营规模', '日常经营资金周转', '设备购置升级'] }
      },
      sheet: { show: false, title: '', options: [], value: '', key: '' }
    }
  },
  methods: {
    selectField(name) {
      const conf = this.fieldOptions[name]
      if (!conf) return
      this.sheet = { show: true, title: '请选择' + name, options: conf.options, value: this.form[conf.key], key: conf.key }
    },
    onFormClick(e) {
      const item = e.target.closest('.form-item')
      if (!item) return
      const label = item.querySelector('.form-label')
      if (label) this.selectField(label.textContent.replace(/^\*/, ''))
    },
    onSheetSelect(val) {
      this.form[this.sheet.key] = val
      this.sheet.show = false
    },
    uploadMaterial() {
      this.$alert('请上传营业执照、经营场所证明、身份证明等材料（演示环境）')
    },
    handleSubmit() {
      const f = this.form
      const checks = [
        [!f.region, '请选择注册区划'],
        [!f.creditCode, '请输入统一信用代码'],
        [!f.entityName, '请输入经营实体名称'],
        [!f.loanCount, '请输入贷款次数'],
        [!f.establish, '请选择成立年限'],
        [!f.business, '请选择经营状态'],
        [!f.employ, '请选择用工规模'],
        [!f.among, '请选择重点群体用工情况'],
        [!f.personType, '请选择人员类别'],
        [!f.mobile, '请输入移动电话'],
        [!f.marital, '请选择婚姻状况'],
        [!f.purpose, '请选择借款用途']
      ]
      for (const [cond, msg] of checks) {
        if (cond) { this.$alert(msg); return }
      }
      if (!/^[0-9A-Z]{18}$/.test(f.creditCode)) {
        this.$alert('请输入18位统一社会信用代码')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(f.mobile)) {
        this.$alert('请输入正确的移动电话')
        return
      }
      this.$alert('未查询到该人员名下的企业信息，请先采集单位基础信息后再申请贷款')
    }
  }
}
</script>

<style scoped>
.loan-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.notice-card {
  margin: calc(20 * var(--w)) calc(24 * var(--w)) 0;
  background: #FFFBEF;
  border-radius: calc(12 * var(--w));
  padding: calc(28 * var(--w)) calc(32 * var(--w));
}
.notice-title {
  font-size: calc(30 * var(--w));
  font-weight: bold;
  color: #B07A1E;
  margin-bottom: calc(12 * var(--w));
}
.notice-line {
  font-size: calc(26 * var(--w));
  color: #8A6D3B;
  line-height: 1.8;
}
.section-title {
  font-size: calc(30 * var(--w));
  font-weight: bold;
  color: #323233;
  padding: calc(24 * var(--w)) calc(32 * var(--w)) calc(16 * var(--w));
}
.form-body {
  background: #fff;
}
.form-item {
  display: flex;
  align-items: center;
  min-height: calc(110 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
  gap: calc(24 * var(--w));
}
.form-item:last-child {
  border-bottom: none;
}
.form-label {
  font-size: calc(30 * var(--w));
  color: #323233;
  white-space: nowrap;
  width: calc(220 * var(--w));
  flex-shrink: 0;
}
.form-label.required::before {
  content: '*';
  color: #f00;
  margin-right: calc(4 * var(--w));
}
.form-input {
  flex: 1;
  height: calc(110 * var(--w));
  border: none;
  outline: none;
  font-size: calc(30 * var(--w));
  color: #323233;
  background: transparent;
}
.form-input::placeholder {
  color: #969799;
}
.picker {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.picker-value {
  font-size: calc(30 * var(--w));
  color: #323233;
}
.picker-value.placeholder {
  color: #969799;
}
.picker-arrow {
  width: calc(28 * var(--w));
  height: calc(28 * var(--w));
  flex-shrink: 0;
}
.footer-btns {
  display: flex;
  gap: calc(24 * var(--w));
  padding: calc(40 * var(--w)) calc(32 * var(--w));
}
.upload-btn,
.submit-btn {
  flex: 1;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
.modal {
  width: calc(600 * var(--w));
  background: #fff;
  border-radius: calc(16 * var(--w));
  overflow: hidden;
}
.modal-title {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  text-align: center;
  padding: calc(40 * var(--w)) calc(32 * var(--w)) calc(16 * var(--w));
}
.modal-body {
  font-size: calc(30 * var(--w));
  color: #646566;
  text-align: center;
  padding: calc(16 * var(--w)) calc(32 * var(--w)) calc(40 * var(--w));
}
.modal-btn {
  border-top: 1px solid #f0f0f0;
  text-align: center;
  font-size: calc(34 * var(--w));
  color: #2E8CF6;
  padding: calc(28 * var(--w)) 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/LoanApply.vue